<template>
	<li class="cate-mega-menu w-1/3 px-3 py-4 rtl:border-l ltr:border-r border-primary" :class="{'bg-gray-100' :menuOpened}">
		<button class="focus:outline-none text-secondary-100 text-center flex" @click.prevent="menuControl">
			<i class="icon icon-show text-3xl"></i>
			<span class="rtl:mr-1 ltr:ml-1 self-center">{{ sitelocale == 'en' ? 'Categories Menu' : 'قائمة الأقسام'}}</span>
		</button>
		<div class="mega-menu-content" :class="{'menu_opened' :menuOpened}" >
			<div class="container m-auto bg-gray-100 shadow rounded-b-md">
				<div class="flex flex-wrap content-center justify-start">
					<div class="w-1/3 px-2 border-l border-primary">
						<ul class="py-2 mega-menu-list">
							<li v-for="category in categories" class="py-2 px-2" :class="[category == currentCat ? 'text-orange font-semibold' :'text-secondary-100' ]">
								<a class="focus:outline-none hover:text-orange flex content-center justify-between" @mouseover.prevent="openSub(category)" :href="`/${sitelocale}/${categoriesRoute}/${category.slug}`">									
									<span>
										<i class="text-xl rtl:ml-1 ltr:mr-1" :class="category.icon_class"></i>
										{{category.name}}
									</span>
									<button class="focus:outline-none">
										<i v-if="sitelocale == 'ar'" class="fas fa-chevron-left hover:text-orange focus:outline-none"></i>
										<i v-if="sitelocale == 'en'" class="fas fa-chevron-right hover:text-orange focus:outline-none"></i>
									</button>
								</a>
								
							</li>							
						</ul>
					</div>
					<div class="w-2/3 px-2">
						<div class="flex flex-wrap content-center justify-start py-1">
							<div v-for="sub_cat in currentCat.sub_categories" class="w-1/3 py-1 px-2">
								<a class="focus:outline-none inline-block text-secondary-100 hover:text-orange text-sm" :href="`/${sitelocale}/${subCategoriesRoute}/${sub_cat.slug}/products`">{{sub_cat.name}}</a>
							</div>
						</div>
						<!-- <div>Slick</div> -->
					</div>
				</div>
			</div>
		</div>
		
	</li>
</template>
<script>

	export default {
		name: "MegaMenu",
		props: {
			
			categories:{
				type: Array,
				required: true
			},
			categoriesRoute:{
				type: String,
				required: true
			},
			subCategoriesRoute:{
				type: String,
				required: true
			},
			sitelocale:{
				type: String,
				required: true
			},
		},
		data() {
			return {
				menuOpened:false,
				currentCat:[]
			};
		},
		mounted() {
			this.$translate.setLang(this.sitelocale);
		},
		created() {
			
		},
		methods: {
			openSub(category){
				this.currentCat = category;
			},
			menuControl(){
				if(this.menuOpened==true){
					this.menuOpened = false;
				}else{
					this.menuOpened = true
				}
			}
		},

	};
</script>



// WEBPACK FOOTER //
// resources/assets/js/front/components/SiteComponents/MegaMenu.vue